import type { FrontendWidget } from '../types';
import { MagazineTeaserTextComponent } from './MagazineTeaserTextComponent';
import type {
  MagazineTeaserTextConfig,
  MagazineTeaserTextResolved,
} from './types';

/**
 * Inline, **context-backed** (30.03.05 § Classification): `resolveSync` and no
 * backend resolver — the block carries no fields and reads its entity from
 * `ctx.entities`.
 */
export const magazineTeaserTextWidget: FrontendWidget<
  MagazineTeaserTextConfig,
  MagazineTeaserTextResolved
> = {
  componentType: 'magazine.teaser-text',
  displayName: 'Magazine Teaser Text',
  ComponentA: MagazineTeaserTextComponent,
  resolveSync: () => ({}),
};
